import React from "react";
import "./roadClosureWorkPermitAll.css";

const Template9 = ({ permitClosure }) => {
  console.log("permitClosure", permitClosure);

  const formatDateTime = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);
    const time = date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: "UTC",
    });
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();

    return `${day}/${month}/${year}, ${time}`;
  };

  return (
    <div className="rc_template-container">
      <div className="template-container-content">
        <div className="template-container-header">
          <div className="cold-remark">
            <h4>कार्य अनुमति पत्र बंद करना / Closing of the work permit</h4>
          </div>
          <div className="rc-work-table">
            <table className="rc-work-table">
              <colgroup>
                <col style={{ width: "12%" }} />
                <col style={{ width: "18%" }} />
                <col style={{ width: "12%" }} />
                <col style={{ width: "12%" }} />
                <col style={{ width: "18%" }} />
                <col style={{ width: "12%" }} />
                <col style={{ width: "16%" }} />
              </colgroup>
              <thead>
                <tr>
                  <th colSpan="3" className="permit-closing table-closing1">
                    प्राप्तकर्ता: प्रमाणित किया जाता है कि विषयगत कार्य पूरा हो गया है / रोक दिया गया है तथा क्षेत्र साफ कर दिया गया है।
                    <br />
                    Receiver: Certified that the subject work has been
                    completed
                    <input
                      type="checkbox"
                      className="permit-check"
                      checked={permitClosure.completion_status === 1}
                      readOnly
                    />
                    stopped
                    <input
                      type="checkbox"
                      className="permit-check"
                      checked={permitClosure.stoppage_status === 1}
                      readOnly
                    />
                    and area cleaned.
                  </th>
                  <th colSpan="3" className="permit-closing table-closing1">
                    जारीकर्ता: सत्यापित किया जाता है कि काम पूरा हो गया है, क्षेत्र साफ कर दिया गया है और स्थल किसी भी खतरे से सुरक्षित है।
                    <br />
                    Issuer: Verified that the job has been completed, the area
                    has been cleaned, and the site is safe from hazards.
                  </th>
                  <th colSpan="1" className="permit-center-align table-closing2">
                    सुरक्षा अधिकारी <br /> Safety Officer
                  </th>
                </tr>
                <tr>
                  <th className="permit-center-align">दिनांक एवं समय <br /> Date & Time</th>
                  <th className="permit-center-align">नाम और पद <br /> Name & Designation</th>
                  <th className="permit-center-align">हस्ताक्षर <br /> Signature</th>
                  <th className="permit-center-align">दिनांक एवं समय <br /> Date & Time</th>
                  <th className="permit-center-align">नाम और पद <br /> Name & Designation</th>
                  <th className="permit-center-align">हस्ताक्षर <br /> Signature</th>
                  <th className="permit-center-align">नाम और हस्ताक्षर <br /> Name & Signature</th>
                </tr>
              </thead>
              <tbody>
                <tr className="permit-row-end">
                  <td>{formatDateTime(permitClosure.receiver_date_time)}</td>
                  <td>{permitClosure.receiver_name}</td>
                  <td></td>
                  <td>{formatDateTime(permitClosure.issuer_date_time)}</td>
                  <td>{permitClosure.issuer_name}</td>
                  <td></td>
                  <td>{permitClosure.safety_officer_name}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Template9;
